import { render, staticRenderFns } from "./ModuleNewsTickerForm.vue?vue&type=template&id=62b42226&scoped=true"
import script from "./ModuleNewsTickerForm.vue?vue&type=script&lang=js"
export * from "./ModuleNewsTickerForm.vue?vue&type=script&lang=js"
import style0 from "./ModuleNewsTickerForm.vue?vue&type=style&index=0&id=62b42226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b42226",
  null
  
)

export default component.exports